import { HttpApi } from "@kosmod/pancake";
import { Game, GameID, gamesAPI } from "../defs";
import { AuthState } from "./useAuthState";
import { useMemo, useState } from "@lukekaalim/act";
import { LOADING, useAsync, useRefresh } from "@kosmod/kit";
import { InvitationDescription, InvitationID } from "../defs/invitation";

/**
 * A view into games (plural) management
 */
export type GamesState = {
  /**
   * A list of all games you are a player in.
   */
  all: LOADING | Game[],
  
  refresh(): void,
  createGame(name: string): Promise<Game>,

  createInvitation(game: GameID, addressedTo: string): Promise<InvitationDescription>,
  acceptInvitation(game: GameID, invitationId: InvitationID, code: string): Promise<void>,

  api: HttpApi.Handler<"client", typeof gamesAPI>
}

export const useGamesState = (api: HttpApi.Handler<"client", typeof gamesAPI>): GamesState => {
  const [refresh, key] = useRefresh();

  const { result: gameResult } = useAsync(async () => {
    const { games } = await api["/"].GET({ gameId: null }, null);

    return games;
  }, [api, key]);

  return useMemo(() => ({
    all: gameResult || LOADING,
    api,

    refresh,
    async createGame(name) {
      const { game } = await api["/"].POST(null, { name });
      refresh();
      return game;
    },
    async createInvitation(game, addressedTo) {
      const { invitation } = await api['invitation'].POST(null, {
        game,
        addressedTo
      })
      return invitation;
    },
    async acceptInvitation(game, invitationId, code) {
      await api['players/by-invitation'].POST(null, { invitationId, game, code })
    },
  }), [gameResult, api])
};
